import { IconType } from './types';

export const ChangeIcon = ({ size = 24, color = 'black' }: IconType) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path
      fill={color}
      d="M7.97 12.53a.75.75 0 0 0 1.06-1.06l-1.06 1.06ZM5.53 7.97a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM5 7.75a.75.75 0 0 0 0 1.5v-1.5Zm14 1.5a.75.75 0 0 0 0-1.5v1.5ZM4.47 7.97a.75.75 0 0 0 1.06 1.06L4.47 7.97Zm4.56-2.44a.75.75 0 0 0-1.06-1.06l1.06 1.06Zm7 5.94a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm2.44 4.56a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm.53.22a.75.75 0 0 0 0-1.5v1.5Zm-14-1.5a.75.75 0 0 0 0 1.5v-1.5Zm14.53 1.28a.75.75 0 1 0-1.06-1.06l1.06 1.06Zm-4.56 2.44a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm-5.94-7-3.5-3.5-1.06 1.06 3.5 3.5 1.06-1.06ZM5 9.25h14v-1.5H5v1.5Zm.53-.22 3.5-3.5-1.06-1.06-3.5 3.5 1.06 1.06Zm9.44 3.5 3.5 3.5 1.06-1.06-3.5-3.5-1.06 1.06ZM19 14.75H5v1.5h14v-1.5Zm-.53.22-3.5 3.5 1.06 1.06 3.5-3.5-1.06-1.06Z"
    />
  </svg>
);
